const initModalResponse = () => {
    const modal = document.querySelector("[data-modal-response-form]");
    if (modal) {
        const closeModal = modal.querySelector("[data-close-icon]");
        closeModal.addEventListener('click', () => {
            modal.setAttribute("data-modal-response-form", "inactive");
        });
        const url = new URL(window.location.href);
        const modalResponse = url.searchParams.get("contact") === "1";
        const errorResponse = url.searchParams.get("contact") === "0";
        if (modalResponse || errorResponse) {
            modal.removeAttribute("data-modal-response-form");
            if (modalResponse) {
                modal.setAttribute("data-modal-response-form", "success");
            }
            if (errorResponse) {
                modal.setAttribute("data-modal-response-form", "error");
            }
        }
    }
};
